import React from 'react';

import { Log } from '../../../entities/log';
import { Pagination } from '../../../entities/pagination';
import PaginationComponent from '../../../components/common/pagination';
import { strings } from '../../../localization/strings';

export default function LogsTable({
  logs,
  pagination,
  onUpdate,
}: {
  logs: Log[];
  pagination: Pagination;
  onUpdate: (pageNo: number) => void;
}) {
  const getCompanyLabel = (log: Log): string => {
    if (!log.company) {
      return '';
    }

    if (log.user?.company_id === 1) {
      return '';
    }

    return ` (${log.company})`;
  };

  return (
    <>
      <div className="flex flex-col">
        <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle sm:px-4 lg:px-8">
            <div className="overflow-hidden border-b border-gray-200">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="w-[1%] whitespace-nowrap px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
                      {strings.logs.columns.createdAt}
                    </th>
                    <th className="w-[1%] whitespace-nowrap px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
                      {strings.logs.columns.ip}
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
                      {strings.logs.columns.user}
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
                      {strings.logs.columns.action}
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white">
                  {logs.map((log) => (
                    <tr key={log.id}>
                      <td className="whitespace-nowrap px-4 py-3 text-sm text-gray-900">
                        {log.created_at_formatted || '-'}
                      </td>
                      <td className="whitespace-nowrap px-4 py-3 text-sm text-gray-600">{log.ip || '-'}</td>
                      <td className="px-4 py-3 text-sm text-gray-600">
                        {log.username || '-'}
                        {getCompanyLabel(log)}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-600">{log.action_label}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <PaginationComponent pagination={pagination} onChangePage={onUpdate} />
    </>
  );
}
